import DOMPurify from 'dompurify';

export type SanitationLevel = 'strict' | 'permissive' | 'svg';

type SanitizerOptions = {
  ALLOWED_TAGS?: string[];
  ALLOWED_ATTR?: string[];
  ALLOW_DATA_ATTR?: boolean;
  USE_PROFILES?: {
    svg: boolean;
  };
};

const strict: SanitizerOptions = {
  ALLOWED_TAGS: [
    'a',
    'b',
    'blockquote',
    'br',
    'code',
    'del',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'li',
    'ol',
    'p',
    'pre',
    's',
    'span',
    'strike',
    'strong',
    'table',
    'tbody',
    'td',
    'tfooter',
    'th',
    'thead',
    'tr',
    'ul',
  ],
  ALLOWED_ATTR: [
    // anchors
    'href',
    'target',
  ],
  ALLOW_DATA_ATTR: false,
};

const permissive: SanitizerOptions = {
  ALLOWED_TAGS: [
    ...strict.ALLOWED_TAGS!,
    'img',
    // for video
    'iframe',
  ],
  ALLOWED_ATTR: [
    ...strict.ALLOWED_ATTR!,
    // tables
    'align',
    'colspan',
    'rowspan',
    // general
    'id',
    'class',
    'style',
    // anchors
    'rel',
    'title',
    // img and iframe (for video)
    'src',
    'alt',
    // iframe tags (for video)
    'width',
    'height',
    'frameborder',
    'webkitallowfullscreen',
    'mozallowfullscreen',
    'allowfullscreen',
  ],
  ALLOW_DATA_ATTR: true,
};

const svg: SanitizerOptions = {
  USE_PROFILES: {
    svg: true,
  },
};

const purifyOptions: Record<SanitationLevel, SanitizerOptions> = {
  strict,
  permissive,
  svg,
};

export const sanitize = (html: string, sanitationLevel: SanitationLevel) =>
  DOMPurify.sanitize(html, purifyOptions[sanitationLevel]);
